import { requestConfig } from "../config.js";

/**
 * Получить ссылку на страницу авторизации на портале Госуслуги
 *
 * @param {String} redirectUrl
 * @param {?String} apiKey
 */
export default async function apiFetchLinkAuth(redirectUrl, apiKey = null) {
  const response = await requestConfig.get("/api/v0/gosuslugi/auth_url/", {
    params: {
      url: redirectUrl,
      key: apiKey,
    },
  });

  return response.data?.detail;
}
